export default __webpack_public_path__ + "static/media/366.0ca15041.gif";